import { render, staticRenderFns } from "./TaskMessageBox.vue?vue&type=template&id=b0781372&scoped=true&"
import script from "./TaskMessageBox.vue?vue&type=script&lang=js&"
export * from "./TaskMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./TaskMessageBox.vue?vue&type=style&index=0&id=b0781372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0781372",
  null
  
)

export default component.exports